import {Component, OnInit} from '@angular/core';
import {DataSyncLogsService} from "./data-sync-logs.service";
import {MessageService} from "primeng/api";
import {FormControl, FormGroup} from "@angular/forms";
import {Platform} from "@angular/cdk/platform";

@Component({
    selector: 'app-data-sync-logs',
    templateUrl: './data-sync-logs.component.html',
    styleUrls: ['./data-sync-logs.component.scss']
})
export class DataSyncLogsComponent implements OnInit {

    date: any = new Date();

    onWhereClause = false;
    logTypes: any[] = [];
    // logTypes: any[] = [
    //     {
    //         name: 'Data Sync',
    //         columnFields: ['SHORT_MESSAGE', 'DETAILED_MESSAGE', 'SOURCE', 'IDENTIFIER_VALUE', 'IDENTIFIER_TYPE']
    //     },
    //     {
    //         name: 'Notification STG',
    //         columnFields: ['USER_ID', 'BOOKING_ID', 'BUSINESS_ENTITY_ID', 'DOMAIN_ID', 'TRANSACTION_TYPE', 'MESSAGE_PAYLOAD', 'NOTIFY_TO_PHONE_NUMBER', 'NOTIFICATION_DATE', 'FAILED', 'ERROR_DETAILS']
    //     },
    //     {
    //         name: 'Notification Whatsapp',
    //         columnFields: ['USER_ID', 'BOOKING_ID', 'BUSINESS_ENTITY_ID', 'DOMAIN_ID', 'TRANSACTION_TYPE', 'MESSAGE_PAYLOAD', 'NOTIFY_TO_PHONE_NUMBER', 'NOTIFICATION_DATE', 'FAILED', 'ERROR_INFO', 'STATUS']
    //     },
    //     {
    //         name: 'SI Document Data Sync',
    //         columnFields: ['ERROR_DETAILS', 'BOOKING_ID', 'DOCUMENT_DEF_XID', 'STATUS', 'IDENTIFIER_TYPE', 'SI_DOC_ID', 'SI_CONTAINER_DOC_ID', 'ORDER_RELEASE_GID']
    //     },
    //     {
    //         name: 'SI Document OTM Sync',
    //         columnFields: ['SI_DOC_ID', 'IS_ERROR_UPLOADING_DOC', 'ERROR_DETAILS', 'BOOKING_ID', 'DOC_DEF_XID', 'IDENTIFIER_TYPE']
    //     }
    // ];
    logsFilterForm: FormGroup;
    dataLogs: any;
    isLoading = false;
    isError: boolean;

    constructor(private logService: DataSyncLogsService, private messageService: MessageService,
                public platform: Platform) {
    }

    ngOnInit(): void {
        this.date.setDate(this.date.getDate() - 10);
        this.createLogsFilterForm();
        this.getLogTypes();
    }


    getLogs(logsFilter: any) {
        this.dataLogs = null;
        this.isLoading = true;
        this.logService.getLogs(logsFilter)
            .subscribe((x) => {
                this.isLoading = false;
                console.log(x);
                this.dataLogs = x;
            }, error => {
                this.isError = true;
                this.isLoading = false;
                this.messageService.add({
                    summary: 'Data logs Error !',
                    severity: 'error',
                    detail: error?.message ? error?.message : error,
                    key: 'logs-error',
                    life: 3000
                });
            });
    }

    onExecuteLogsFilter() {
        const logFilterValue = this.logsFilterForm.value;
        this.getLogs(logFilterValue);
    }

    getLogTypes() {
        this.logService.getLogTypes()
            .subscribe((x) => {
                this.logTypes = x;
                this.logsFilterForm?.controls?.logType?.setValue(this.logTypes[0]);
            }, error => {
                this.messageService.add({
                    summary: 'Log Types Error !',
                    severity: 'error',
                    detail: error?.message ? error?.message : error,
                    key: 'logs-error',
                    life: 3000
                });
            });
    }

    createLogsFilterForm() {
        this.logsFilterForm = new FormGroup({
            fromDateTime: new FormControl(this.date),
            toDateTime: new FormControl(new Date()),
            logType: new FormControl(),
            additionalWhereClause: new FormControl()
        });
    }
}
